module.exports = __webpack_public_path__ + "img/hc_pro_ten_18.437bac29.jpg";